import styled from "styled-components";
import Header from "./components/Banner/Header";
import ProfComponent from "./components/Banner/ProfComponent";
import Clients from "./components/Clients/Clients";
import Footer from "./components/Footer/Footer";
import Projects from "./components/Projects/Projects";
import Services from "./components/Service/Services";
import Skills from "./components/Skills/Skills";
import About from "./components/About/About";
import Experience from "./components/Experience/Experience";
import Qualification from "./components/Qualification/Qualification";
function App() {
  return (
    // <HelmetProvider>
    // <Helmet>
    //   {/* Primary Meta Tags */}
    //   <title>Usama Bajwa - Top Software Engineer | Power BI Developer</title>
    //   <meta
    //     name="description"
    //     content="Usama Bajwa - Experienced Software Engineer and Power BI Developer in Pakistan. Specializing in Data Analytics, React, and Business Intelligence."
    //   />
    //   <meta
    //     name="keywords"
    //     content="Usama Bajwa, Muhammad Usama, Software Engineer, Power BI Developer, Data Analyst, React Developer, Full Stack Developer, Lahore, Pakistan"
    //   />
    //   <meta name="author" content="Usama Bajwa" />

    //   {/* Open Graph (Facebook, LinkedIn) */}
    //   <meta property="og:title" content="Usama Bajwa - Software Engineer & Power BI Developer" />
    //   <meta
    //     property="og:description"
    //     content="Expert in Data Analytics, Power BI, and Full Stack Development. Helping businesses with custom dashboards and BI solutions."
    //   />
    //   <meta property="og:image" content="https://usama-bajwa.vercel.app/profile-image.jpg" />
    //   <meta property="og:url" content="https://usama-bajwa.vercel.app" />
    //   <meta property="og:type" content="profile" />

    //   {/* Twitter Card */}
    //   <meta name="twitter:card" content="summary_large_image" />
    //   <meta name="twitter:title" content="Usama Bajwa - Software Engineer | Power BI Developer" />
    //   <meta name="twitter:description" content="Power BI and Data Analytics Expert from Pakistan, specializing in Business Intelligence and Full Stack Development." />
    //   <meta name="twitter:image" content="https://usama-bajwa.vercel.app/profile-image.jpg" />

    //   {/* Canonical URL */}
    //   <link rel="canonical" href="https://usama-bajwa.vercel.app" />
    // </Helmet>
    <Container>
      <Banner>
        <Header />
        <ProfComponent />
      </Banner>
      <Banner2>
        <About />
      </Banner2>
      <LightColor>
        <Skills />
      </LightColor>
      <Services />
      <LightColor>
        <Qualification />
      </LightColor>
      <Experience />
      <LightColor>
        <Projects />
      </LightColor>
      <Clients />
      <LightColor>
        <Footer />
      </LightColor>
    </Container>
  );
}

export default App;

const Container = styled.div``;
const Banner = styled.div`
  background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
  height: 100vh;
  @media (max-width: 640px) {
    height: 100%;
    padding-bottom: 2rem;
  }
`;
const Banner2 = styled.div`
  height: 100vh;
  padding: auto;
  @media (max-width: 640px) {
    height: 100%;
    padding-bottom: 2rem;
  }
`;

const LightColor = styled.div`
  background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
`;
